import OidcUserManager from 'oidc-service';
import { APP_ROLES } from 'store/enums';
import { removeRememberMeCookie } from 'helpers/cookies';

// Security
const oidcUserManager = new OidcUserManager();

export const userSignIn = (loginHint, state, acrValues) =>
  oidcUserManager.signIn(loginHint, state, acrValues);

export const userSignOut = () => {
  removeRememberMeCookie();
  oidcUserManager.signOut();
};

export const userSigninRedirectCallback = () => oidcUserManager.signinRedirectCallback();

export const userRole = async () => {
  const role = await oidcUserManager.getRole();
  return role;
};

export const userProfile = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile;
};

export const userPartnerId = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.partnerid;
};

export const userName = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.name;
};

export const userContactId = async () => {
  const profile = await oidcUserManager.getProfile();
  return profile.contactId;
};

export const userSignedIn = async () => {
  const signedIn = await oidcUserManager.getSignedIn();
  return signedIn;
};

export const userAcessTokenAndType = async () => {
  const token = await oidcUserManager.getAcessTokenAndType();
  return token;
};

export const checkAvailabilityRole = (role, check) => role.some(item => check.indexOf(item) !== -1);

export const userHasAldRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_ADMIN, APP_ROLES.ALD_USER]);
};

export const userHasDeveloperRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_DEVELOPER]);
};

export const userHasOnlyAldRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.ALD_ADMIN]);
};

export const userHasPartnerRole = async () => {
  const role = await oidcUserManager.getRole();
  return checkAvailabilityRole(role, [APP_ROLES.PARTNER_ADMIN, APP_ROLES.PARTNER_USER]);
};

export const isCampaignIdSale = id => {
  const stringId = id.toString();
  if (stringId.match(/\d+-\d+/)) {
    return true;
  }
  return false;
};
